import React, { Component } from 'react'
export class Logo extends Component {
  render() {
    return (
      <div className='flex flex-col items-center'>
        <img src={"https://rightsandroots.com/assets/logo-D6cW2tK7.png"} alt="Logo" />
      </div>
    )
  }
}

export default Logo